import themes from '@/data/themes'
import { CLIENT } from '@/utils/getEnv'
import { FC } from 'react'
import styled from 'styled-components'
import UtilButton from '../chat/ChatPane/UtilButton'
import { ModalTitle } from '../settings/SettingsUtilComponent'
import useModal from '../utils/useModal'

type Props = {
  setIsAccept: (value: boolean) => void
}

type UseTermsAndConditionModal = {
  openTermsAndCondtitionsModal: () => void,
  TermsAndConditionsModal: FC<Props>
}

const useTermsAndConditionsModal = (): UseTermsAndConditionModal => {
  const { Modal, ModalCloseButton, openModal, closeModal } = useModal()

  const TermsAndConditionsModal: FC<Props> = ({ setIsAccept }) => {

    return (
      <>
        <Modal id="termsAndConditions" styleContentModal={{ width: 'max-content' }}>
          <ModalCloseButton style={{ float: 'right' }} />
          <ModalTitle>Terms and Conditions</ModalTitle>
          <br />
          <Content>
            <Subtitle2>
              PQ ini merupakan satu kesatuan dari Form CMD. Kecuali ditentukan lain dalam PQ ini , definisi-definisi dalam PQ ini akan memiliki arti yang sama sebagaimana ditetapkan dalam Ketentuan Berlangganan pada Form CMD.
            </Subtitle2>
            <Subtitle2 style={{ color: '#7B7B7B' }}>
            This PQ is an integral part of the CMD form. Unless otherwise stated in this PQ, the definitions in this PQ will have the same meaning as stated in the Subscription Terms to the CMD Form.
            </Subtitle2>
            <StyledOl>
              <li>
                <Body1 >Harga yang tertera di atas adalah dalam satuan Rupiah.</Body1>
                <Body1 style={{ color: '#7B7B7B' }}>Price stated above is in IDR (Rp - Rupiah).</Body1>
              </li>
              <li>
                <Body1 >Kecuali diatur lain pada PQ dan lampiran, Pelanggan dengan ini setuju untuk membayar denda (penalty) sebagaimana disebutkan pada Ketentuan Berlangganan. </Body1>
                <Body1 style={{ color: '#7B7B7B' }}>Unless otherwise stated in PQ and its attachment, Customer hereby agrees to pay a penalty as stated in the Subscription Terms.</Body1>
              </li>
              <li>
                <Body1 >Penghitungan tagihan akan dimulai setelah layanan aktif berdasarkan tanggal aktivasi pertama kali atau Berita Acara  yang telah ditandatangani oleh para pihak (mana yang relevan). </Body1>
                <Body1 style={{ color: '#7B7B7B' }}>Charging will be started once the service is activated based on the first activation date or based on the signed  certificate (berita acara), whichever is relevant.</Body1>
              </li>
              <li>
                <Body1 >Berita acara akan diterbitkan setelah layanan aktif. Pelanggan dianggap menyetujui berita acara  tersebut jika selama 5 hari kerja sejak tanggal penerbitan berita acara dimaksud, tidak ada respon/tanggapan atau alasan penolakan yang wajar dari Pelanggan dan MMB (Minimum Monthly Billing) akan diberlakukan.</Body1>
                <Body1 style={{ color: '#7B7B7B' }}>Certificate (berita acara) will be issued after the service has been activated. Customer is deemed had been agreed to the certificate (berita acara)if within 5 working days since such the issuance date of certificate, there is no response/feedback or reasonable reason for rejection from Customer and MMB (Minimum Monthly Billing) will be applied.</Body1>
              </li>
              <li>
                <Body1 >Kecuali diatur lain pada PQ dan lampiran, Pelanggan dengan ini setuju untuk membayar denda (penalty) sebagaimana disebutkan pada Ketentuan Berlangganan. </Body1>
                <Body1 style={{ color: '#7B7B7B' }}>Unless otherwise stated in PQ and its attachment, Customer hereby agrees to pay a penalty as stated in the Subscription Terms.</Body1>
              </li>
            </StyledOl>
          </Content>


          <UtilButton variant="contained" color='primary' type="button" style={{ float: 'right' }} onClick={() => {
            setIsAccept(true)
            closeModal()
          }}>
            ACCEPT
          </UtilButton>
          <div style={{ padding: 8, float: 'right' }} />
          <UtilButton variant="outlined" color='primary' type="button" style={{ float: 'right' }} onClick={() => {
            setIsAccept(false)
            closeModal()
          }}>
            DECLINE
          </UtilButton>
        </Modal>
      </>
    )
  }

  return {
    openTermsAndCondtitionsModal: () => {
      openModal('termsAndConditions')
    },
    TermsAndConditionsModal
  }


}

export default useTermsAndConditionsModal

const Subtitle2 = styled.div`
  font-family: 'Trueno', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  /* or 150% */


  color: #000000;
`
const Body1 = styled.div`
  font-family: 'Trueno';
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
`

const StyledOl = styled.ol`
  padding: 0 18px 0 16px;
  font-family: 'Trueno';
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  li {
    padding-bottom: 8px;
  }
`

const Content = styled.div`
  max-width: 770px;
  max-height: 50vh;
  overflow-y: auto;
  margin-bottom: 16px;
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${(themes[CLIENT || '']?.muiTheme?.palette?.primary as any)?.main as string || '#D0D6DD'} ;
    border-radius: 0;
  }
`